import React, { Component } from "react";
import "./QueueLogsDashboard.css";
import { getInformationWithData } from '../../services/CABE.js';
// Menu
import { Menu } from "../../components/Menu/Menu";

export default class QueueLogsDashboard extends Component {
  constructor(props) {
    super(props);

    const today = this.formatDateInput(new Date());
    const sevenDaysAgo = this.formatDateInput(this.addDays(new Date(), -7));

    this.state = {
      loading: false,
      error: "",
      logs: [],

      // filters
      dateStart: sevenDaysAgo,
      dateEnd: today,
      status: "",
      action: "",
      companyId: "",
      requestId: "",
      page: 1,
      pageSize: 50,

      // ui
      autoRefresh: false,
      autoRefreshSec: 10,
      selectedLog: null,
      showModal: false,
    };

    this._refreshTimer = null;
  }

  componentDidMount() {
    this.fetchLogs();
  }

  componentWillUnmount() {
    this.clearAutoRefresh();
  }

  addDays(date, days) {
    const d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  formatDateInput(date) {
    // YYYY-MM-DD
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return y + "-" + m + "-" + d;
  }

  setAutoRefresh(enabled) {
    this.setState({ autoRefresh: enabled }, () => {
      if (this.state.autoRefresh) {
        this.clearAutoRefresh();
        const ms = (Number(this.state.autoRefreshSec) || 10) * 1000;
        this._refreshTimer = setInterval(() => this.fetchLogs(false), ms);
      } else {
        this.clearAutoRefresh();
      }
    });
  }

  clearAutoRefresh() {
    if (this._refreshTimer) {
      clearInterval(this._refreshTimer);
      this._refreshTimer = null;
    }
  }

  async fetchLogs(setLoading) {
    const shouldSetLoading = typeof setLoading === "undefined" ? true : setLoading;

    try {
      if (shouldSetLoading) this.setState({ loading: true, error: "" });

      const body = {
        data: {
          dateStart: this.state.dateStart,
          dateEnd: this.state.dateEnd,
          status: this.state.status || undefined,
          action: this.state.action || undefined,
          companyId: this.state.companyId || undefined,
          page: this.state.page,
          pageSize: this.state.pageSize,
        },
      };

      // const json = await res.json();
      const resp = await getInformationWithData('/v2/queue/list', body);

      if (resp.status.code !== 1) {
        const msg = (resp && (resp.error || (resp.status && resp.status.Description))) || "Error loading logs";
        this.setState({ loading: false, error: msg, logs: [] });
        return;
      }

      // let rows = json.data || [];
      // if (!Array.isArray(rows)) rows = [];
      let rows = resp.data.data;
      console.log("----- rows");
      console.log(rows);

      // client-side filter: requestId contains (porque tu endpoint aun no filtra por requestId)
      const reqFilter = (this.state.requestId || "").trim();
      if (reqFilter) {
        rows = rows.filter((r) => String(r.requestId || "").indexOf(reqFilter) !== -1);
      }

      this.setState({ loading: false, logs: rows, error: "" });
    } catch (err) {
      this.setState({
        loading: false,
        error: err && err.message ? err.message : String(err),
        logs: [],
      });
    }
  }

  onChangeField(field, value) {
    const next = {};
    next[field] = value;
    // si cambias filtros reinicia a page 1
    if (
      field === "dateStart" ||
      field === "dateEnd" ||
      field === "status" ||
      field === "action" ||
      field === "companyId"
    ) {
      next.page = 1;
    }
    this.setState(next);
  }

  applyFilters() {
    this.setState({ page: 1 }, () => this.fetchLogs());
  }

  clearFilters() {
    const today = this.formatDateInput(new Date());
    const sevenDaysAgo = this.formatDateInput(this.addDays(new Date(), -7));

    this.setState(
      {
        dateStart: sevenDaysAgo,
        dateEnd: today,
        status: "",
        action: "",
        companyId: "",
        requestId: "",
        page: 1,
      },
      () => this.fetchLogs()
    );
  }

  openModal(log) {
    this.setState({ selectedLog: log, showModal: true });
  }

  closeModal() {
    this.setState({ selectedLog: null, showModal: false });
  }

  statusClass(s) {
    const st = String(s || "").toLowerCase();
    if (st === "done") return "badge badge--done";
    if (st === "error") return "badge badge--error";
    if (st === "dead") return "badge badge--dead";
    if (st === "processing") return "badge badge--processing";
    if (st === "claimed") return "badge badge--claimed";
    return "badge badge--pending";
  }

  fmtDateTime(v) {
    if (!v) return "";
    // ya viene como string SQL, lo mostramos tal cual
    return String(v).replace("T", " ").slice(0, 19);
  }

  nextPage() {
    this.setState({ page: this.state.page + 1 }, () => this.fetchLogs());
  }

  prevPage() {
    const p = this.state.page - 1;
    this.setState({ page: p < 1 ? 1 : p }, () => this.fetchLogs());
  }

  renderModal() {
    if (!this.state.showModal || !this.state.selectedLog) return null;

    const log = this.state.selectedLog;

    return (
      <div className="modalOverlay" onClick={() => this.closeModal()}>
        <div className="modalCard" onClick={(e) => e.stopPropagation()}>
          <div className="modalHeader">
            <div>
              <div className="modalTitle">Log detail</div>
              <div className="modalSub">
                <span className={this.statusClass(log.status)}>{log.status}</span>
                <span className="mono small"> {log.requestId}</span>
              </div>
            </div>
            <button className="btn btn--ghost" onClick={() => this.closeModal()}>
              Close
            </button>
          </div>

          <div className="modalBody">
            <div className="grid2">
              <div className="kv">
                <div className="k">Company</div>
                <div className="v">{log.companyId}</div>
              </div>
              <div className="kv">
                <div className="k">Action</div>
                <div className="v">{log.action}</div>
              </div>
              <div className="kv">
                <div className="k">Attempts</div>
                <div className="v">{log.attempts}</div>
              </div>
              <div className="kv">
                <div className="k">Priority</div>
                <div className="v">{log.priority}</div>
              </div>

              <div className="kv">
                <div className="k">Claimed</div>
                <div className="v">{this.fmtDateTime(log.claimedAt)}</div>
              </div>
              <div className="kv">
                <div className="k">Started</div>
                <div className="v">{this.fmtDateTime(log.startedAt)}</div>
              </div>
              <div className="kv">
                <div className="k">Finished</div>
                <div className="v">{this.fmtDateTime(log.finishedAt)}</div>
              </div>
              <div className="kv">
                <div className="k">Ms</div>
                <div className="v">{log.processingMs || ""}</div>
              </div>
            </div>

            <div className="section">
              <div className="sectionTitle">Error</div>
              <pre className="pre">{log.errorMessage || ""}</pre>
            </div>

            <div className="section">
              <div className="sectionTitle">Request payload</div>
              <pre className="pre">{log.requestPayload || ""}</pre>
            </div>

            <div className="section">
              <div className="sectionTitle">Response payload</div>
              <pre className="pre">{log.responsePayload || ""}</pre>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, error, logs } = this.state;

    return (
      <div className="page">
        {/* Main menu */}
        <Menu Refresh={this.state.Refresh} Father={this} />

        <div className="topBar" style={{marginTop: 20}}>
          <div>
            <div className="title">Queue Logs</div>
            <div className="subtitle">Monitor de procesos del servidor local</div>
          </div>

          <div className="topActions">
            <button className="btn" onClick={() => this.fetchLogs()}>
              Refresh
            </button>

            <label className="switch">
              <input
                type="checkbox"
                checked={this.state.autoRefresh}
                onChange={(e) => this.setAutoRefresh(e.target.checked)}
              />
              <span className="slider" />
              <span className="switchLabel">Auto</span>
            </label>

            <input
              className="input input--small"
              type="number"
              min="5"
              max="120"
              value={this.state.autoRefreshSec}
              onChange={(e) => this.setState({ autoRefreshSec: e.target.value })}
              disabled={!this.state.autoRefresh}
              title="Seconds"
            />
          </div>
        </div>

        <div className="card">
          <div className="filters">
            <div className="field">
              <div className="label">Start</div>
              <input
                className="input"
                type="date"
                value={this.state.dateStart}
                onChange={(e) => this.onChangeField("dateStart", e.target.value)}
              />
            </div>

            <div className="field">
              <div className="label">End</div>
              <input
                className="input"
                type="date"
                value={this.state.dateEnd}
                onChange={(e) => this.onChangeField("dateEnd", e.target.value)}
              />
            </div>

            <div className="field">
              <div className="label">Status</div>
              <select
                className="input"
                value={this.state.status}
                onChange={(e) => this.onChangeField("status", e.target.value)}
              >
                <option value="">All</option>
                <option value="pending">pending</option>
                <option value="claimed">claimed</option>
                <option value="processing">processing</option>
                <option value="done">done</option>
                <option value="error">error</option>
                <option value="dead">dead</option>
              </select>
            </div>

            <div className="field">
              <div className="label">Action</div>
              <input
                className="input"
                placeholder="e.g. getList"
                value={this.state.action}
                onChange={(e) => this.onChangeField("action", e.target.value)}
              />
            </div>

            <div className="field">
              <div className="label">Company</div>
              <input
                className="input"
                placeholder="e.g. 3"
                value={this.state.companyId}
                onChange={(e) => this.onChangeField("companyId", e.target.value)}
              />
            </div>

            <div className="field">
              <div className="label">RequestId contains</div>
              <input
                className="input"
                placeholder="q_..."
                value={this.state.requestId}
                onChange={(e) => this.onChangeField("requestId", e.target.value)}
              />
            </div>

            <div className="filterActions">
              <button className="btn" onClick={() => this.applyFilters()}>
                Apply
              </button>
              <button className="btn btn--ghost" onClick={() => this.clearFilters()}>
                Clear
              </button>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="tableHeader">
            <div className="tableTitle">Logs</div>
            <div className="tableMeta">
              Page <b>{this.state.page}</b> · Showing <b>{logs.length}</b>
              {loading ? <span className="dotLoading">•</span> : null}
            </div>
          </div>

          {error ? <div className="errorBox">{error}</div> : null}

          <div className="tableWrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Action</th>
                  <th>Company</th>
                  <th>Attempts</th>
                  <th>Ms</th>
                  <th>RequestId</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {logs.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="empty">
                      {loading ? "Loading..." : "No logs found"}
                    </td>
                  </tr>
                ) : null}

                {logs.map((log) => (
                  <tr key={log.id || log.requestId}>
                    <td>
                      <span className={this.statusClass(log.status)}>{log.status}</span>
                    </td>
                    <td className="mono">{this.fmtDateTime(log.createdAt)}</td>
                    <td>{log.action}</td>
                    <td className="mono">{log.companyId}</td>
                    <td className="mono">{log.attempts}</td>
                    <td className="mono">{log.processingMs || ""}</td>
                    <td className="mono small">{log.requestId}</td>
                    <td className="right">
                      <button className="btn btn--ghost" onClick={() => this.openModal(log)}>
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="pager">
            <button className="btn btn--ghost" onClick={() => this.prevPage()} disabled={this.state.page <= 1 || loading}>
              Prev
            </button>
            <button className="btn btn--ghost" onClick={() => this.nextPage()} disabled={loading || logs.length < this.state.pageSize}>
              Next
            </button>
          </div>
        </div>

        {this.renderModal()}
      </div>
    );
  }
}